import React, { useEffect, useState, useRef } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import Button from '../buttonApp/Button';
import QuizDisplay from './QuizDisplay';
import { Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material';
import { usePxToVw } from '../../../hooks/usePxToVw';

const TrivaMainTopics = ({
  menu,
  settings,
  clicked,
  handleQuizTextClick,
  handleQuizAnimationComplete,
  topicquestions,
  triviaQuizSettings,
  brandColor,
  screenSteps,
  backToMenu,
  resetSession,
  brandFont,
  selectedTopicId,
  currentUserId,
}) => {
  // console.log("screenSteps",screenSteps, " topicquestions",settings )

  const updatedSettings = {
    ...settings,
    globalSettings: {
      ...settings.globalSettings,
      clickSound: settings?.clickSound?.fileUrl,
      clickSoundVolume: settings?.clickSoundVolume,
    },
  };
  const [editOpen, setEditOpen] = useState(false);
  const [countdown, setCountdown] = useState(5);
  const timerRef = useRef(null);

  const [windowSize, setWindowSize] = useState({
    width: window.innerWidth,
    height: window.innerHeight,
  });

  const { pxToVw, getMaxWidth } = usePxToVw();

  useEffect(() => {
    if (screenSteps === 4) {
      if (timerRef.current) clearTimeout(timerRef.current);

      timerRef.current = setTimeout(() => {
        setCountdown(5);
        setEditOpen(true);
      }, 10000); // 10 seconds

      return () => clearTimeout(timerRef.current); // Cleanup timer if component unmounts or screenSteps changes
    } else {
      setEditOpen(false);
    }
  }, [screenSteps]);

  useEffect(() => {
    if (editOpen && countdown > 0) {
      const timer = setInterval(() => {
        setCountdown(prev => prev - 1);
      }, 1000);
      return () => clearInterval(timer); // Cleanup function
    } else if (countdown === 0) {
      handleCountdownComplete();
    }
  }, [editOpen, countdown]);

  const handleCountdownComplete = () => {
    console.log('Countdown finished! Perform action here.');
    // Close the dialog after countdown
    //resetSession();
    clearTimeout(timerRef.current);
    setEditOpen(false);
    setCountdown(5);
    resetSession();
  };

  const modalClodeFun = () => {
    setEditOpen(false);

    if (screenSteps === 4) {
      if (timerRef.current) clearTimeout(timerRef.current);

      timerRef.current = setTimeout(() => {
        setCountdown(5);
        setEditOpen(true);
      }, 10000); // 10 seconds

      return () => clearTimeout(timerRef.current); // Cleanup timer if component unmounts or screenSteps changes
    } else {
      setEditOpen(false);
    }
  };

  useEffect(() => {
    if (clicked && settings?.disableAnimation) {
      handleQuizAnimationComplete(0);
    }
  }, [clicked]);

  const renderButtons = () => {
    if (settings?.numColumns === 'center-single-row') {
      const sortedMenu = [...(menu || [])].sort((a, b) => a.order - b.order);

      return (
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            flexWrap: 'wrap',
            gap: `${pxToVw(settings?.columnSpacing)}`,
          }}
        >
          {sortedMenu.map((item, index) => {
            const ButtonWrapper = settings?.disableAnimation ? 'div' : motion.div;
            const animationProps = settings?.disableAnimation
              ? {
                  onClick: () => handleQuizTextClick(item?.id),
                }
              : {
                  custom: { index, type: clicked ? 'slideOut' : 'visible' },
                  initial: 'hidden',
                  animate: clicked ? 'slideOut' : 'visible',
                  variants: {
                    hidden: custom => ({
                      x: item.side === 'left' ? '-100vw' : '100vw',
                      opacity: 1,
                      transition: {
                        type: 'spring',
                        damping: 15,
                        stiffness: 100,
                        delay: index * 0.2,
                      },
                    }),
                    visible: custom => ({
                      x: 0,
                      opacity: 1,
                      transition: {
                        type: 'spring',
                        damping: 15,
                        stiffness: 100,
                        delay: index * 0.2,
                      },
                    }),
                    slideOut: custom => ({
                      x: item.side === 'left' ? '-100vw' : '100vw',
                      opacity: 1,
                      transition: {
                        type: 'spring',
                        damping: 15,
                        stiffness: 100,
                        delay: 1 + (sortedMenu.length - 1 - custom.index) * 0.2,
                      },
                    }),
                  },

                  onClick: () => handleQuizTextClick(item?.id),
                  onAnimationComplete: definition => {
                    if (definition === 'slideOut') {
                      handleQuizAnimationComplete(index);
                    }
                  },
                };

            return (
              <ButtonWrapper
                key={index}
                {...animationProps}
                className="text-item"
                // onClick={() => handleTextClick(item?.id, item?.linkbtnId)}
              >
                <Button
                  key={index}
                  text={item?.name}
                  settings={updatedSettings?.globalSettings}
                  keyid={item?.id}
                />
              </ButtonWrapper>
            );
          })}
        </div>
      );
    } else if (settings?.numColumns === 'center-two-buttons-per-row') {
      const leftButtons = (menu || []).filter(item => item.side === 'left');
      const rightButtons = (menu || []).filter(item => item.side === 'right');

      return (
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            gap: `${pxToVw(settings?.columnSpacing)}`,
          }}
        >
          {/* Left Column */}
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              gap: `${pxToVw(settings?.columnSpacing)}`,
            }}
          >
            {leftButtons.map((item, index) => {
              const ButtonWrapper = settings?.disableAnimation ? 'div' : motion.div;
              const animationProps = settings?.disableAnimation
                ? {
                    onClick: () => {
                      clearTimeout(timerRef.current);
                      handleQuizTextClick(item?.id);
                    },
                  }
                : {
                    custom: { index, direction: 'left' },
                    initial: 'hidden',
                    animate: clicked ? 'slideOut' : 'visible',
                    variants: {
                      hidden: custom => ({
                        x: '-100vw',
                        opacity: 1,
                        scale: 0.95,
                        transition: {
                          type: 'easeInOut',
                          damping: 30,
                          duration: 1,
                          stiffness: 20,
                          delay: custom.index * 0.15,
                        },
                      }),
                      visible: custom => ({
                        x: 0,
                        opacity: 1,
                        scale: 1,
                        transition: {
                          ease: 'easeInOut',
                          damping: 30,
                          duration: 1,
                          stiffness: 20,
                          delay: custom.index * 0.15,
                        },
                      }),
                      slideOut: custom => ({
                        x: '-100vw',
                        opacity: 0,
                        scale: 0.95,
                        transition: {
                          ease: 'easeInOut',
                          duration: 1,
                          delay: 1 + (leftButtons.length - 1 - custom.index) * 0.15,
                        },
                      }),
                    },

                    onClick: () => {
                      clearTimeout(timerRef.current);
                      handleQuizTextClick(item?.id);
                    },
                  };
              return (
                <ButtonWrapper
                  key={index}
                  {...animationProps}
                  className="text-item"
                  // onClick={() => handleTextClick(item?.id, item?.linkbtnId)}
                >
                  <Button
                    key={index}
                    text={item?.name}
                    settings={updatedSettings?.globalSettings}
                    keyid={item?.id}
                  />
                </ButtonWrapper>
              );
            })}
          </div>

          {/* Right Column */}
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              gap: `${pxToVw(settings?.columnSpacing)}`,
            }}
          >
            {rightButtons.map((item, index) => {
              const ButtonWrapper = settings?.disableAnimation ? 'div' : motion.div;
              const animationProps = settings?.disableAnimation
                ? {
                    onClick: () => {
                      clearTimeout(timerRef.current);
                      handleQuizTextClick(item?.id);
                    },
                  }
                : {
                    custom: { index, direction: 'right' },
                    initial: 'hidden',
                    animate: clicked ? 'slideOut' : 'visible',
                    variants: {
                      hidden: custom => ({
                        x: '100vw',
                        opacity: 1,
                        scale: 0.95,
                        transition: {
                          type: 'easeInOut',
                          damping: 30,
                          duration: 1,
                          stiffness: 20,
                          delay: custom.index * 0.15,
                        },
                      }),
                      visible: custom => ({
                        x: 0,
                        opacity: 1,
                        scale: 1,
                        transition: {
                          ease: 'easeInOut',
                          damping: 30,
                          duration: 1,
                          stiffness: 20,
                          delay: custom.index * 0.15,
                        },
                      }),
                      slideOut: custom => ({
                        x: '100vw',
                        opacity: 0,
                        scale: 0.95,
                        transition: {
                          ease: 'easeInOut',
                          duration: 1,
                          delay: 1 + (rightButtons.length - 1 - custom.index) * 0.15,
                        },
                      }),
                    },

                    onClick: () => {
                      clearTimeout(timerRef.current);
                      handleQuizTextClick(item?.id);
                    },
                    onAnimationComplete: definition => {
                      if (definition === 'slideOut') {
                        handleQuizAnimationComplete(index);
                      }
                    },
                  };
              return (
                <ButtonWrapper
                  key={index}
                  {...animationProps}
                  className="text-item"
                  // onClick={() => handleTextClick(item?.id, item?.linkbtnId)}
                >
                  <Button
                    key={index}
                    text={item?.name}
                    settings={updatedSettings?.globalSettings}
                    keyid={item?.id}
                  />
                </ButtonWrapper>
              );
            })}
          </div>
        </div>
      );
    } else if (settings?.numColumns === 'right-side-one-button-per-row') {
      const sortedMenu = [...(menu || [])].sort((a, b) => a.order - b.order);

      return (
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            gap: `${pxToVw(settings?.columnSpacing)}`,
          }}
        >
          {sortedMenu.map((item, index) => {
            const ButtonWrapper = settings?.disableAnimation ? 'div' : motion.div;
            const animationProps = settings?.disableAnimation
              ? {
                  onClick: () => {
                    clearTimeout(timerRef.current);
                    handleQuizTextClick(item?.id);
                  },
                }
              : {
                  custom: { index, direction: 'right' },
                  initial: 'hidden',
                  animate: clicked ? 'slideOut' : 'visible',
                  variants: {
                    hidden: custom => ({
                      x: '100vw',
                      opacity: 1,
                      scale: 0.95,
                      transition: {
                        type: 'easeInOut',
                        damping: 30,
                        duration: 1,
                        stiffness: 20,
                        delay: custom.index * 0.15,
                      },
                    }),
                    visible: custom => ({
                      x: 0,
                      opacity: 1,
                      scale: 1,
                      transition: {
                        ease: 'easeInOut',
                        damping: 30,
                        duration: 1,
                        stiffness: 20,
                        delay: custom.index * 0.1,
                      },
                    }),
                    slideOut: custom => ({
                      x: '100vw',
                      opacity: 0,
                      scale: 0.95,
                      transition: {
                        ease: 'easeInOut',
                        duration: 1,
                        delay: 1 + (sortedMenu.length - 1 - custom.index) * 0.15,
                      },
                    }),
                  },

                  onClick: () => {
                    clearTimeout(timerRef.current);
                    handleQuizTextClick(item?.id);
                  },
                  onAnimationComplete: definition => {
                    if (definition === 'slideOut') {
                      handleQuizAnimationComplete(index);
                    }
                  },
                };
            return (
              <ButtonWrapper
                key={index}
                {...animationProps}
                className="text-item"
                // onClick={() => handleTextClick(item?.id, item?.linkbtnId)}
              >
                <Button
                  key={index}
                  text={item?.name}
                  settings={updatedSettings?.globalSettings}
                  keyid={item?.id}
                />
              </ButtonWrapper>
            );
          })}
        </div>
      );
    } else if (settings?.numColumns === 'left-side-one-button-per-row') {
      const sortedMenuu = [...(menu || [])].sort((a, b) => a.order - b.order);

      return (
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            gap: `${pxToVw(settings?.columnSpacing)}`,
          }}
        >
          {sortedMenuu.map((item, index) => {
            const ButtonWrapper = settings?.disableAnimation ? 'div' : motion.div;
            const animationProps = settings?.disableAnimation
              ? {
                  onClick: () => {
                    clearTimeout(timerRef.current);
                    handleQuizTextClick(item?.id);
                  },
                }
              : {
                  custom: { index },
                  initial: 'hidden',
                  animate: clicked ? 'slideOut' : 'visible',
                  exit: 'slideOut', // Ensures exit animation is applied
                  variants: {
                    hidden: custom => ({
                      x: '-100vw',
                      opacity: 1,
                      scale: 0.95,
                      transition: {
                        type: 'easeInOut',
                        damping: 30,
                        duration: 1,
                        stiffness: 20,
                        delay: custom.index * 0.15,
                      },
                    }),
                    visible: custom => ({
                      x: 0,
                      opacity: 1,
                      scale: 1,
                      transition: {
                        ease: 'easeInOut',
                        damping: 30,
                        duration: 1,
                        stiffness: 20,
                        delay: custom.index * 0.1,
                      },
                    }),
                    slideOut: custom => ({
                      x: '-100vw',
                      opacity: 0,
                      scale: 0.95,
                      transition: {
                        ease: 'easeInOut',
                        duration: 1,
                        delay: 1 + (sortedMenuu.length - 1 - custom.index) * 0.15,
                      },
                    }),
                  },

                  onClick: () => {
                    clearTimeout(timerRef.current);
                    handleQuizTextClick(item?.id);
                  },
                  onAnimationComplete: definition => {
                    if (definition === 'slideOut') {
                      handleQuizAnimationComplete(index);
                    }
                  },
                };
            return (
              <ButtonWrapper
                key={index}
                {...animationProps}
                className="text-item"
                // onClick={() => handleTextClick(item?.id, item?.linkbtnId)}
              >
                <Button
                  key={index}
                  text={item?.name}
                  settings={updatedSettings?.globalSettings}
                  keyid={item?.id}
                />
              </ButtonWrapper>
            );
          })}
        </div>
      );
    }
  };

  useEffect(() => {
    const handleResize = () => {
      setWindowSize({
        width: window.innerWidth,
        height: window.innerHeight,
      });
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  // Responsive padding calculation
  const getResponsivePadding = () => {
    if (windowSize.width < 768) return '8px';
    if (windowSize.width < 1200) return '12px';
    return '15px';
  };

  // Responsive margin calculation
  const getResponsiveMargin = () => {
    if (windowSize.width < 768) return '10px';
    if (windowSize.width < 1200) return '15px';
    return '20px';
  };

  // Responsive logo size calculation
  const getResponsiveLogoSize = baseSize => {
    if (windowSize.width < 480) return Math.min(baseSize, 80);
    if (windowSize.width < 768) return Math.min(baseSize, 100);
    if (windowSize.width < 1200) return Math.min(baseSize, 120);
    return Math.min(baseSize, 150);
  };

  return (
    <div>
      {screenSteps === 4 && (
        <>
          <div className="corner-overlays-responsive">
            <AnimatePresence mode="wait">
              <motion.div
                //className="video-container"
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                exit={{ opacity: 0 }}
                transition={{ duration: 2 }}
                className="corner-item top-left"
                style={{ justifyContent: 'left' }}
              >
                <img
                  src={triviaQuizSettings?.leftTopMediaTopic?.fileUrl}
                  alt="Logo"
                  style={{
                    width: 'auto',
                    height: 'auto',
                    //  maxWidth: '20vw',
                    maxWidth: getMaxWidth('25vw'),
                    // maxHeight: '25vw',
                    display: triviaQuizSettings?.leftTopMediaTopic?.enabled ? 'block' : 'none',
                    // height: "130px",
                  }}
                />
              </motion.div>
            </AnimatePresence>

            <AnimatePresence mode="wait">
              <motion.div
                className="corner-item top-right"
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                exit={{ opacity: 0 }}
                transition={{ duration: 2 }}
                style={{ justifyContent: 'right' }}
              >
                <img
                  src={triviaQuizSettings?.rightTopMediaTopic?.fileUrl}
                  alt="Logo"
                  style={{
                    width: 'auto',
                    height: 'auto',
                    //  maxWidth: '20vw',

                    display: triviaQuizSettings?.rightTopMediaTopic?.enabled ? 'block' : 'none',
                    // height: "130px",
                    maxWidth: getMaxWidth('25vw'),
                    // maxHeight: '25vw'
                  }}
                />
              </motion.div>
            </AnimatePresence>

            <AnimatePresence mode="wait">
              <motion.div
                className="corner-item bottom-right"
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                exit={{ opacity: 0 }}
                transition={{ duration: 2 }}
                style={{ justifyContent: 'right' }}
              >
                <img
                  src={triviaQuizSettings?.rightBottomMediaTopic?.fileUrl}
                  alt="Logo"
                  style={{
                    width: 'auto',
                    height: 'auto',
                    maxWidth: getMaxWidth('25vw'),
                    display: triviaQuizSettings?.rightBottomMediaTopic?.enabled ? 'block' : 'none',
                    // height: "130px",
                  }}
                />
              </motion.div>
            </AnimatePresence>

            <AnimatePresence mode="wait">
              <motion.div
                className="corner-item bottom-left"
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                exit={{ opacity: 0 }}
                transition={{ duration: 2 }}
                style={{ justifyContent: 'left' }}
              >
                <img
                  src={triviaQuizSettings?.leftBottomMediaTopic?.fileUrl}
                  alt="Logo"
                  style={{
                    width: 'auto',
                    height: 'auto',
                    maxWidth: getMaxWidth('25vw'),
                    display: triviaQuizSettings?.leftBottomMediaTopic?.enabled ? 'block' : 'none',
                    // height: "130px",
                  }}
                />
              </motion.div>
            </AnimatePresence>

            <AnimatePresence mode="wait">
              <motion.div
                className="corner-item back-button"
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                exit={{ opacity: 0 }}
                transition={{ duration: 2 }}
              >
                <img
                  src={triviaQuizSettings?.backMenuMedia?.fileUrl}
                  alt="Logo"
                  style={{
                    cursor: 'pointer',
                    maxWidth: getMaxWidth('30vw'),
                    maxHeight: getMaxWidth('30vw'),
                    width: 'auto',
                    height: 'auto',
                    display: triviaQuizSettings?.backMenuMedia?.enabled ? 'block' : 'none',
                  }}
                  onClick={backToMenu}
                />
              </motion.div>
            </AnimatePresence>
          </div>

          <div
            className="responsive-menu-containerr"
            style={{
              position: 'absolute',
              top: settings?.enableOffset ? `${settings?.topOffset}%` : 0,
              left: settings?.enableOffset ? `${settings?.leftOffset}%` : 0,
              ...(settings?.enableOffset && settings?.rightOffset > 0
                ? { right: `${settings?.rightOffset}%` }
                : {}),
              // right: settings?.enableOffset ? `${settings?.rightOffset}%` : 0,
              ...(settings?.enableOffset ? {} : { width: '100%' }),
              ...(settings?.enableOffset ? {} : { height: '100%' }),
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',
              zIndex: 2,
            }}
          >
            <AnimatePresence mode="wait">
              <motion.div
                className="center-logo-container"
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                exit={{ opacity: 0 }}
                transition={{ duration: 2 }}
              >
                <img
                  src={triviaQuizSettings?.centerLogoMedia?.fileUrl}
                  alt="Logo"
                  style={{
                    marginBottom: getResponsiveMargin(),
                    display: triviaQuizSettings?.centerLogoMedia?.enabled ? 'block' : 'none',
                    // maxWidth: '35vw',
                    // maxHeight: '35vw',
                    width: 'auto',
                    height: 'auto',
                  }}
                />
              </motion.div>
            </AnimatePresence>

            <div
              style={{
                display: 'flex',
                flexDirection: settings?.numColumns === 'center-single-row' ? 'row' : 'column',
                alignItems: 'center',
                justifyContent: 'center',
                width: '100%',
                // gap: "20px" // Add gap between buttons
              }}
            >
              {renderButtons()}
            </div>

            <AnimatePresence mode="wait">
              <motion.div
                //className="video-container"
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                exit={{ opacity: 0 }}
                transition={{ duration: 2 }}
              >
                <img
                  src={triviaQuizSettings?.centerBelowMenuMedia?.fileUrl}
                  alt="Logo"
                  style={{
                    marginBottom: '20px',
                    display: triviaQuizSettings?.centerBelowMenuMedia?.enabled ? 'block' : 'none',
                    // maxWidth: '35vw',
                    // maxHeight: '35vw',
                    width: 'auto',
                    height: 'auto',
                    // maxHeight: "130px"
                  }}
                />
              </motion.div>
            </AnimatePresence>
          </div>
        </>
      )}

      {screenSteps === 5 && (
        <QuizDisplay
          topicquestions={topicquestions || []}
          triviaQuizSettings={triviaQuizSettings}
          brandColor={brandColor}
          backToMenu={backToMenu}
          brandFont={brandFont}
          selectedTopicId={selectedTopicId}
          currentUserId={currentUserId}
        />
      )}

      <Dialog
        open={editOpen}
        onClose={modalClodeFun}
        sx={{
          '& .MuiDialog-paper': {
            backgroundColor: '#FFFFFF', // White modal background
            border: `2px solid ${brandColor}`,
            // padding: `${settings?.topicPadding}px`,
            padding: `2vw`,
            borderRadius: '20px',
            width: '35vw',
            maxWidth: '70vw',
            // marginLeft:`${triviaQuizSettings?.quizsetting?.leftoffset}%`
          },
          '& .MuiBackdrop-root': {
            backgroundColor: 'transparent', // Change this to any color (Example: Red with opacity)
          },
          // "& .MuiDialog-container": {
          //  marginLeft:`${triviaQuizSettings?.quizsetting?.leftoffset}%`,
          //  justifyContent: "unset", // Remove justify-content
          // WebkitJustifyContent: "unset", // Remove -webkit-justify-content
          // },
        }}
      >
        <DialogTitle
          style={{
            textAlign: 'center',
            // fontSize:`${settings?.topicFontSize}px`,
            fontSize: `3vw`,
            fontFamily: brandFont,
            // lineHeight:settings?.topicLineHeight
          }}
        >
          Are You There?
        </DialogTitle>

        <DialogTitle
          style={{
            textAlign: 'center',
            // fontSize:`${settings?.topicFontSize}px`,
            fontSize: `3vw`,
            fontFamily: brandFont,
            // lineHeight:settings?.topicLineHeight
          }}
        >
          {countdown}
        </DialogTitle>
        <DialogActions>
          <button
            style={{
              margin: '0 auto',
              background: brandColor,
              fontFamily: brandFont,
              fontSize: `2vw`,
              height: 'auto',
              maxHeight: '10vw',
              padding: '0.5vw 1vw',
            }}
            onClick={modalClodeFun}
          >
            Yes
          </button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default TrivaMainTopics;
